<template>
  <div
    @click="navigateToActivation"
    class="px-4 pt-3 pb-4 border-b border-total-white-500 flex flex-col items-start w-full cursor-pointer"
    :class="activation.isActive ? 'bg-dark-grey' : 'bg-pitch-black'"
  >
    <!-- Top Section -->
    <div class="flex w-full justify-between items-center mb-2">
      <h3 class="text-lg font-bold text-total-white text-left">
        {{ getFormattedAddress() }} by
        {{ getFieldValue("first_name", ["account"]) || "Unknown" }}
        {{ getFieldValue("last_name", ["account"]).charAt(0) || "U" }}
      </h3>
      <!-- Status Indicator -->
      <div
        class="text-sm font-medium"
        :class="getFieldValue('is_active') == true ? 'text-dark-green' : 'text-dark-red'"
      >
        ● {{ getFieldValue("is_active") == true ? "active" : "inactive" }}
      </div>
    </div>

    <!-- Bottom Section -->
    <div class="rounded-lg shadow-md flex justify-between items-end w-full">
      <!-- Left Details -->
      <div class="text-left">
        <p class="text-sm text-total-white-800">
          {{ getFieldValue("agent_name") == "N/A" ? "No Agent assigned" : getFieldValue("agent_name") }}
        </p>
        <p class="text-sm mt-2 text-total-white-800">
          {{
            getFieldValue("is_active") == true ? "activated at " + parseDate(getFieldValue("date_updated")) : "deactivated at " + parseDate(getFieldValue("date_updated"))
          }}
        </p>
      </div>

      <!-- Right Chevron Icon -->
      <div class="flex items-center gap-3 pb-1">
        <!-- Chevron -->
        <img
          src="@/assets/images/right-chevron.svg"
          alt="Chevron"
          width="16"
          height="16"
          class="text-prime-golden"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { useRouter } from "vue-router";
import { parseDate } from "@/misc/util";

// Props
const props = defineProps({
  activation: {
    type: Object,
    required: true,
  },
});

const router = useRouter();

// Navigation Handler
const navigateToActivation = () => {
  console.log(props.activation);
  router.push({
    name: "ViewActivationPage",
    params: { id: props.activation.project.id },
  });
};

const getFormattedAddress = () => {
  const address = getFieldValue("address_1", ["project"]);
  return address && address.length > 20
    ? `${address.slice(0, 17)}...`
    : address || "Unknown Project";
};

function formatActivationTime(dateString) {
  if (!dateString) return null;

  try {
    const date = new Date(dateString);
    const options = {
      hour: "2-digit",
      minute: "2-digit",
      timeZoneName: "short",
    };

    const time = date.toLocaleTimeString("en-US", options);
    const formattedDate = date.toLocaleDateString("en-US", {
      month: "2-digit",
      day: "2-digit",
      year: "numeric",
    });

    return `activated at ${time} on ${formattedDate}`;
  } catch (error) {
    console.error("Error formatting activation time:", error);
    return null;
  }
}

// Add `getFieldValue` method here or import it from a utility file.
const getFieldValue = (key, customOrder = ["activation", "project", "account"]) => {
  const fallbackOrder = customOrder;

  const findKeyInObject = (obj, searchKey) => {
    if (!obj || typeof obj !== "object") return undefined;

    if (obj.hasOwnProperty(searchKey)) {
      return obj[searchKey];
    }

    for (const value of Object.values(obj)) {
      const result = findKeyInObject(value, searchKey);
      if (result !== undefined) {
        return result;
      }
    }

    return undefined;
  };

  for (const source of fallbackOrder) {
    if (props.activation[source]) {
      const value = findKeyInObject(props.activation[source], key);
      if (value !== undefined) {
        return value || "N/A";
      }
    }
  }

  return "N/A";
};
</script>
